export default (): string => {
  const canonical: HTMLLinkElement | null = document.querySelector(
    'link[rel="canonical"]'
  )

  return canonical && canonical.href ? canonical.href : window.location.href
}
